import Mediator from './Mediator';
import moment from 'moment';

class Student extends Mediator {
  constructor(student) {
    super(student);

    if (student instanceof Mediator) {
      return this;
    }

    this.setVersion('v1', [
      'sName', 'schoolStudentID', 'sEmail',
      'sAge', 'list', 'class_count', 'sGender',
      'sState',
    ]);

    this.setVersion('v2', [
      'age', 'arrangeLessonCount', 'classStudentFeeState',
      'classStudentState', 'class_feeType', 'days_left',
      'paidTotalQuantity', 'schoolStudentEmail', 'schoolStudentGender',
      'paidInFee',
    ]);

    this.setVersion('v3', [
      'id', 'ssAge', 'ssGender', 'ssName',
    ]);

    this.setVersion('v4', [
      'student_id', 'student_name', 'student_nickname', 'student_age',
    ]);

    this.setVersion('v5', [
      "id","ssFirstName","ssLastName","ssNickName","ssGender",
      "ssBirthday","ssPhone","ssHomePhone","ssEmail","ssSource","ssSocialType","ssSocialID",
      "ssParentsName","ssGuardianRelation","ssParentsPhone","ssParentsEmail",
      "ssParents2Name","ssGuardian2Relation","ssParents2Phone","ssParents2Email",
      "ssCountry","ssProvince","ssCity","ssSuitNumber","ssPostcode","ssAddress",
      "ssRemark","ssState","ssStudentCreateTime","ssCode","student_bound","parents_bound",
      "custom_data","ssSchool","ssStudent", 'balance', 'currency', 'pofile_photo', 
      'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x', "ssPhone_parsed",
      'ssParentsPhone_parsed', 'ssParents2Phone_parsed'
    ]);

    this.setVersion('v6', [
      'sFirstName', 'sLastName', 'sNickName', 'sGender', 'sBirthday', 'sPhone',
      'sHomePhone', 'sEmail', 'sSource', 'sSocialID', 'sParentsName', 'sGuardianRelation',
      'sCountry', 'sProvince', 'sCity', 'sSuitNumber', 'sPostcode', 'sAddress',
      'sRemark', 'sCreateTime', "sParentsName","sGuardianRelation", "sParentsPhone",
      "sParentsEmail","sParents2Name", "sGuardian2Relation","sParents2Phone","sParents2Email",
      "custom_data", 'pofile_photo', 'profile_photo_thumbnail_1x', 'profile_photo_thumbnail_2x', 'profile_photo_thumbnail_8x',
    ]);

    this.__schema = {
      id: {
        alias: ['schoolStudentID', 'sID', 'id', 'student_id'],
        // transform: ()=> {}, // a function to transform the data
      },
      name: {
        alias: ['schoolStudentName', 'sName', 'ssName', 'name', 'student_name'],
        transform: ({name, firstName, lastName})=>{
          if (typeof name == 'string' && name.length > 0) {
            return name;
          } else {
            return `${firstName || ''} ${lastName || ''}`;
          }
        },
      },
      firstName: {
        alias: ['ssFirstName', 'sFirstName'],
        validate: ['required'],
      },
      lastName: {
        alias: ['ssLastName', 'sLastName'],
        validate: ['required'],
      },
      nickName: {
        alias: ['sNickName', 'ssNickName', 'student_nickname'],
      },
      age: {
        alias: ['age', 'sAge', 'ssAge', 'student_age'],
      },
      dob: {
        alias: ['ssBirthday', 'sBirthday'],
        transform: ({dob})=>{
          if (dob && moment(dob).isValid()) {
            return moment(dob).format('YYYY-MM-DD');
          } else {
            return dob;
          }
        },
        validate: [(value)=>{
          if (value && !moment(value).isValid()) {
            return ['not in YYYY-MM-DD format'];
          } else {
            return [];
          }
        }],
      },
      email: {
        alias: ['schoolStudentEmail', 'sEmail', 'ssEmail'],
        validate: ['email'],
      },
      gender: {
        alias: ['schoolStudentGender', 'sGender', 'ssGender'],
        transform: ({gender})=>{
          if (typeof gender === 'string') {
            const genderA = gender.toUpperCase();

            if (genderA == 'MALE' || genderA.indexOf('男') > -1 || genderA == 'BOY' || genderA == 'MAN') {
              return 0;
            }

            if (genderA == 'FEMALE' || genderA.indexOf('女') > -1 || genderA == 'GIRL' || genderA == 'WOMAN') {
              return 1;
            }

            return 3;

          } else if (typeof gender === 'number') {
            return gender;
          }
        }
      },
      countryCode: {
        alias: ['countryCode'],
      },
      phone: {
        alias: ['ssPhone', 'sPhone'],
        validate: ['required', 'phone'],
      },
      phoneParsed: {
        alias: ['ssPhone_parsed']
      },
      homePhone: {
        alias: ['ssHomePhone', 'sHomePhone'],
      },
      country: {
        alias: ['ssCountry', 'sCountry'],
      },
      province: {
        alias: ['ssProvince', 'sProvince'],
      },
      city: {
        alias: ['ssCity', 'sCity'],
      },
      suiteNumber: {
        alias: ['ssSuitNumber', 'sSuitNumber'],
      },
      postalCode: {
        alias: ['ssPostcode', 'sPostcode'],
      },
      address: {
        alias: ['ssAddress', 'sAddress'],
      },

      primaryGuardianName: {
        alias: ['ssParentsName', 'sParentsName'],
      },
      primaryGuardianEmail: {
        alias: ['ssParentsEmail', 'sParentsEmail'],
        validate: ['email'],
      },
      primaryGuardianPhone: {
        alias: ['ssParentsPhone', 'sParentsPhone'],
        validate: ['phone'],
      },
      primaryGuardianPhoneParsed: {
        alias: ['ssParentsPhone_parsed', 'sParentsPhone_parsed'],
        validate: ['phone'],
      },
      primaryGuardianRelationship: {
        alias: ['ssGuardianRelation', 'sGuardianRelation'],
      },

      secondaryGuardianName: {
        alias: ['ssParents2Name', 'sParents2Name'],
      },
      secondaryGuardianEmail: {
        alias: ['ssParents2Email', 'sParents2Email'],
        validate: ['email'],
      },
      secondaryGuardianPhone: {
        alias: ['ssParents2Phone', 'sParents2Phone'],
        validate: ['phone'],
      },
      secondaryGuardianPhoneParsed: {
        alias: ['ssParents2Phone_parsed', 'sParents2Phone_parsed'],
        validate: ['phone'],
      },
      secondaryGuardianRelationship: {
        alias: ['ssGuardian2Relation', 'sGuardian2Relation'],
      },

      customData: {
        alias: ['custom_data'],
        transform: function({customData}) {
          // by some unknown errors custom_data is being saved as [object Object]
          // to preven further corruption we adjust it back to {}
          if (typeof customData !== 'object') {
            return {}
          } else {
            return customData;
          }
        }
      },
      remark: {
        alias: ['ssRemark', 'sRemark'],
      },
      code: {
        alias: ['ssCode'],
      },
      studentBound: {
        alias: ['student_bound'],
      },
      parentsBound: {
        alias: ['parents_bound'],
      },
      createdOn: {
        alias: ['ssStudentCreateTime', 'sCreateTime'],
      },

      state: {
        alias: ['sState', 'ssState'],
      },
      arrangeLessonCount: {
        alias: ['arrangeLessonCount']
      },
      classFeeType: {
        alias: ['class_feeType']
      },
      classStudentState: {
        alias: ['classStudentState']
      },
      usedLessonCount: {
        alias: ['usedLessonCount']
      },
      paidTotalQuantity: {
        alias: ['paidTotalQuantity']
      },
      usedTotalQuantity: {
        alias: ['usedTotalQuantity']
      },
      daysLeft: {
        alias: ['days_left']
      },
      paidInFee: {
        alias: ['paidInFee']
      },
      classList: {
        alias: ['list', 'classList'],
        transform: function({ classList }) {
          if (!Array.isArray(classList)) {
            return [];
          }
          return classList.map(function(cls) {
            // sometimes classDetail in class list can have consumed_and_purchased
            // we must to flat it out to make it work with PaymentModal
            if (cls.consumed_and_purchased) {
              return {
                ...cls,
                ...cls.consumed_and_purchased,
              }
            } else {
              return cls;
            }
          });
        }
      },
      classCount: {
        alias: ['class_count'],
      },
      classInfo: {
        alias: ['classInfo'],
      },
      balance: {
        alias: ['blanace']
      },
      currency: {
        alias: ['currency']
      },
      profilePhoto: {
        alias: ['profile_photo'],
      },
      profilePhotoThumbnail1x: {
        alias: ['profile_photo_thumbnail_1x'],
      },
      profilePhotoThumbnail2x: {
        alias: ['profile_photo_thumbnail_2x'],
      },
      profilePhotoThumbnail8x: {
        alias: ['profile_photo_thumbnail_8x'],
      },
    }

    return this.create();
  }

  getAddress() {
    const {
      suiteNumber, address, city, province, country, postalCode,
    } = this.__privateData;

    const suiteNumberStr = typeof suiteNumber === 'string' && suiteNumber.length > 0 ? suiteNumber + ' - ' : '';
    const addressStr = typeof address === 'string' && address.length > 0 ? address : '';
    const cityStr = typeof city === 'string' && city.length > 0 ? city : '';
    const provinceStr = typeof province === 'string' && province.length > 0 ? province : '';
    const countryStr = typeof country === 'string' && country.length > 0 ? country : '';
    const postalCodeStr = typeof postalCode === 'string' && postalCode.length > 0 ? postalCode.toUpperCase() : '';

    return `${suiteNumberStr} ${addressStr} ${cityStr} ${provinceStr} ${countryStr} ${postalCodeStr}`;
  }

  onConvertFormData(name, value) {

  }


}

export default Student;



// WEBPACK FOOTER //
// ./src/mediators/Student.js